// extracted by mini-css-extract-plugin
export default {"tableWrapper":"ServicePaymentsPage_tableWrapper__1nTl2"};